import { b, contactStep } from './helpers'

const extras = {
  type: 'multi',
  text: b('¿Necesitas algo más?', 'Do you need anything else?'),
  hint: b('Opcional.', 'Optional.'),
  icon: 'sparkles',
  optional: true,
  options: [
    { value: 'cotizar-reparacion', label: b('Cotizar reparación', 'Quote a repair') },
    { value: 'cotizar-poliza', label: b('Cotizar póliza', 'Quote a service plan') },
    { value: 'asesoria-tecnica', label: b('Asesoría técnica', 'Technical advice') },
    { value: 'censo', label: b('Censo de equipos', 'Equipment census') },
  ],
  next: 'contacto',
}

const equipoOptions = (next) => [
  { value: 'terminales', label: b('Terminales móviles', 'Mobile computers'), next },
  { value: 'impresoras', label: b('Impresoras', 'Printers'), next },
  { value: 'lectores-rfid', label: b('Lectores RFID', 'RFID readers'), next },
]

export const soporte = {
  id: 'soporte',
  title: b('Solicita soporte', 'Request support'),
  start: 'servicio',
  submit: {
    formName: 'soporte-solicitud',
    fieldMap: { name: 'nombre', email: 'correo', telephone: 'telefono', company: 'empresa', message: 'equipos' },
    extra: { servicio: 'servicio', necesidadesExtra: 'extras' },
  },
  steps: {
    servicio: {
      type: 'choice',
      text: b('¿Qué servicio necesitas?', 'Which service do you need?'),
      icon: 'wrench',
      options: [
        { value: 'reparacion', label: b('Reparación en campo', 'On-site repair'), next: 'rep_equipo' },
        { value: 'preventivo', label: b('Mantenimiento preventivo', 'Preventive maintenance'), next: 'prev_equipo' },
        { value: 'correctivo', label: b('Mantenimiento correctivo', 'Corrective maintenance'), next: 'corr_equipo' },
        { value: 'asesoria', label: b('Asesoría técnica', 'Technical advice'), next: 'ase_tema' },
      ],
    },
    // Reparación
    rep_equipo: { type: 'choice', text: b('¿Qué equipo falla?', 'Which device is failing?'), icon: 'wrench', options: equipoOptions('rep_falla') },
    rep_falla: {
      type: 'text',
      text: b('Describe la falla', 'Describe the issue'),
      hint: b('Síntomas, mensajes de error, desde cuándo.', 'Symptoms, error messages, since when.'),
      icon: 'wrench',
      placeholder: b('Ej. no enciende desde ayer', 'E.g. has not powered on since yesterday'),
      next: 'rep_cantidad',
    },
    rep_cantidad: {
      type: 'choice',
      text: b('¿Cuántos equipos están afectados?', 'How many devices are affected?'),
      icon: 'chart',
      options: [
        { value: '1', label: b('Solo uno', 'Just one'), next: 'extras' },
        { value: '2-10', label: b('De 2 a 10', '2 to 10'), next: 'extras', echo: b('Coordinamos una visita para todos en un solo viaje.', 'We will schedule one visit for all of them.') },
        { value: '10+', label: b('Más de 10', 'More than 10'), next: 'extras', echo: b('Activamos un equipo de atención prioritaria.', 'We will assign a priority response team.') },
      ],
    },
    // Preventivo
    prev_equipo: { type: 'choice', text: b('¿Qué equipos quieres cuidar?', 'Which equipment do you want to maintain?'), icon: 'shield', options: equipoOptions('prev_cantidad') },
    prev_cantidad: { type: 'number', text: b('¿Cuántos equipos son?', 'How many devices?'), icon: 'chart', placeholder: b('Ej. 30', 'E.g. 30'), next: 'prev_frecuencia' },
    prev_frecuencia: {
      type: 'choice',
      text: b('¿Con qué frecuencia?', 'How often?'),
      icon: 'clock',
      options: [
        { value: 'trimestral', label: b('Cada 3 meses', 'Every 3 months'), next: 'extras' },
        { value: 'semestral', label: b('Cada 6 meses', 'Every 6 months'), next: 'extras' },
        { value: 'anual', label: b('Una vez al año', 'Once a year'), next: 'extras' },
        { value: 'asesoria', label: b('No sé, recomiéndenme', 'Not sure, recommend one'), next: 'extras' },
      ],
    },
    // Correctivo
    corr_equipo: { type: 'choice', text: b('¿Qué equipo necesita corrección?', 'Which device needs corrective work?'), icon: 'shield', options: equipoOptions('corr_recurrente') },
    corr_recurrente: {
      type: 'choice',
      text: b('¿Es una falla que se repite?', 'Is it a recurring issue?'),
      icon: 'shield',
      options: [
        { value: 'si', label: b('Sí, ya ha pasado antes', 'Yes, it happened before'), next: 'extras', echo: b('Buscaremos la causa raíz, no solo el síntoma.', 'We will find the root cause, not just the symptom.') },
        { value: 'no', label: b('No, es la primera vez', 'No, first time'), next: 'extras' },
      ],
    },
    // Asesoría
    ase_tema: {
      type: 'choice',
      text: b('¿Sobre qué necesitas asesoría?', 'What do you need advice on?'),
      icon: 'lightbulb',
      options: [
        { value: 'seleccion', label: b('Elegir el equipo correcto', 'Choosing the right equipment'), next: 'ase_detalle' },
        { value: 'etiquetas', label: b('Etiquetas y consumibles', 'Labels and supplies'), next: 'ase_detalle' },
        { value: 'configuracion', label: b('Configuración o integración', 'Setup or integration'), next: 'ase_detalle' },
      ],
    },
    ase_detalle: { type: 'text', text: b('Cuéntanos tu caso', 'Tell us about your case'), icon: 'lightbulb', optional: true, next: 'extras' },
    extras,
    contacto: contactStep,
  },
}
